<template>
    <div class="orp-rate" :class="color">
        <div class="name" @click="go_to_the_circle(orp.id)">{{ orp.name }}</div>
        <div class="ants">
            <OrpAnt v-for="index in 3" :rate="index" :key="index" :per="percents" />
        </div>
    </div>
</template>

<script>
import OrpAnt from './OrpAnt.vue'

export default {
    name: 'OrpRate',
    data: () => ({
        color: 'bg-green',
        percents: {
            low: 0,
            middle: 0,
            high: 0,
        },
    }),
    props: ['orp'],
    components: { OrpAnt },
    computed: {},
    watch: {
        orp: function (val) {
            this.get_image(val.to_rates)
        },
    },
    beforeMount() {
        this.get_image(this.orp.to_rates)
    },
    methods: {
        get_percent(rates, type) {
            if (rates) {
                let x = []
                switch (type) {
                    case 'low':
                        x = rates.filter((rate) => rate.rate == '1')
                        break
                    case 'middle':
                        x = rates.filter((rate) => rate.rate == '2')
                        break
                    case 'high':
                        x = rates.filter((rate) => rate.rate == '3')
                        break

                    default:
                        break
                }
                if (x.length == 0) return `0 %`
            }

            return ` ${((x.length / rates.length) * 100).toFixed()} %`
        },
        get_image(rates) {
            let rates_array = {}

            const low = rates.filter((rate) => rate.rate == '1')
            const middle = rates.filter((rate) => rate.rate == '2')
            const high = rates.filter((rate) => rate.rate == '3')

            rates_array.low = low.length ? ((low.length / rates.length) * 100).toFixed() : 0
            rates_array.middle = middle.length ? ((middle.length / rates.length) * 100).toFixed() : 0
            rates_array.high = high.length ? ((high.length / rates.length) * 100).toFixed() : 0

            this.percents = rates_array
            const max = Object.keys(rates_array).reduce((a, b) => (rates_array[a] * 1 > rates_array[b] * 1 ? a : b))

            switch (max) {
                case 'low':
                    return (this.color = 'bg-blue')

                case 'middle':
                    return (this.color = 'bg-yellow')

                case 'high':
                    return (this.color = 'bg-green')

                default:
                    break
            }
        },

        go_to_the_circle(department_id) {
            this.$router.push({ path: `/rates/orp/${department_id}` })
        },
    },
}
</script>

<style scoped>
.orp-rate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 35px 102px;
    margin-bottom: 5px;
}

.orp-rate:first-child {
    border-radius: 30px 30px 0px 0px;
}

.orp-rate .name {
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #1f0303;
    cursor: pointer;
}

.orp-rate.bg-blue {
    background-color: #e8ebf1;
}

.orp-rate.bg-yellow {
    background-color: #fae8d2;
}

.orp-rate.bg-green {
    background-color: #eaf2e5;
}

.ants {
    display: flex;
}
</style>
